import request from "root/js/request";

export const getMarksProducts = async ({
  product_id,
  end_date__gte,
  end_date__lte,
  start_date__gte,
  start_date__lte,
  limit = 1000,
  offset = 0,
}) => {
  const response = await request({
    url: `/monitoring/marks/products/`,
    method: "get",
    params: {
      product_id,
      end_date__gte,
      end_date__lte,
      start_date__gte,
      start_date__lte,
      limit,
      offset,
    },
  });
  return response.data;
};
